export default class SellLinesRowData {
  constructor(value) {
    this.chargeType = value.chargeType[0] || "";
    this.brand = value.brand[0] || "";
    this.chargePeriodDate = value.chargePeriod[0] || ""; 
    this.vendorNo = value.vendorNo[0] || ""; 
    this.associateVendorNo = value.assVendorNo[0] || ""; 
    this.customerNo = value.custNo[0] || ""; 
    this.raNumber = value.ranumber[0] || ""; 
    this.licenseRentalAgreementNo = value.licRentAgreeNo[0] || ""; 
    this.chargeCode1 = value.cc1[0] || ""; 
    this.netVoucherValue = value.netVouchValue[0] || ""; 
    this.diValue = value.divalue[0] || ""; 
    this.totalSellRentals = value.totalSellRent[0] || ""; 
    this.chargeCode2 = value.cc2[0] || ""; 
    this.voucherFee = value.voucherFee[0] || ""; 
    this.diFee = value.difee[0] || ""; 
    this.totalFee = value.totalFee[0] || ""; 
    this.chargeCode4 = value.cc4[0] || ""; 
    this.chargeCode5 = value.cc5[0] || ""; 
    this.creditClubValuePurchase = value.ccvaluePurchased[0] || ""; 
    this.tmSplit = value.tmsplit[0] || ""; 
    this.cwdSplit = value.cwdsplit[0] || ""; 
    this.tpSplit = value.tpsplit[0] || ""; 
    this.paiSplit = value.paisplit[0] || ""; 
    this.lliSplit = value.llisplit[0] || ""; 
    this.oneWayFee = value.oneWayFee[0] || ""; 
    this.fuel = value.fuel[0] || ""; 
    this.cashRefund = value.cashRefund[0] || ""; 
    this.collection = value.collection[0] || ""; 
    this.tax = value.tax[0] || ""; 
    this.otherDeductions = value.otherDed[0] || ""; 
    this.totalDeductions = value.totalDed[0] || ""; 
    this.chargeCode3 = value.cc3[0] || ""; 
    this.adjustmentValue = value.adjValue[0] || ""; 
    this.adjustmentReasonCode = value.adjReason[0] || ""; 
    this.navReasonCode = value.navreason[0] || ""; 
    this.customerBillingCurrency = value.custBillCurr[0] || ""; 
    this.checkoutDate = value.checkoutDate[0] || ""; 
    this.locationCode = value.locCode[0] || ""; 
    this.checkoutLocation = value.coloc[0] || ""; 
    this.checkinLocation = value.ciloc[0] || ""; 
    this.customerAccountNo = value.custAccNo[0] || ""; 
    this.customerAccountName = value.custAccName[0] || ""; 
    this.iata = value.iata[0] || ""; 
    this.agencyName = value.agencyName[0] || ""; 
    this.voucherNumber = value.voucherNo[0] || ""; 
    this.voucherValue = value.voucherValue[0] || ""; 
    this.voucherCommission = value.vouchComm[0] || ""; 
    this.commissionTax = value.commonTax[0] || ""; 
    this.subTotal = value.subTotal[0] || ""; 
    this.fee = value.fee[0] || ""; 
    this.netBuySell = value.netBuySell[0] || ""; 
    this.countryCodeBoughtFrom = value.countryCode[0] || ""; 
    this.commissionableRevenue = value.commRev[0] || ""; 
    this.commissionPercent = value.commPerc[0] || ""; 
    this.referralCommission = value.refComm[0] || ""; 
    this.referralCommissionTax = value.refCommTax[0] || ""; 
    this.totalReferralCommissionTax = value.totRefCommTax[0] || ""; 
    this.diValueSoldPurchased = value.divalueSoldPurch[0] || ""; 
    this.diBuySellFee = value.dibuySellFee[0] || ""; 
    this.secondaryCreditId = value.secCreditID[0] || ""; 
    this.secondaryCurrencyCode = value.secCurrCode[0] || ""; 
    this.fxRate = value.fxrate[0] || ""; 
    this.clIndicator = value.clind[0] || ""; 
    this.stationIndicator = value.stationInd[0] || ""; 
    this.vehicleRegistrationNo = value.vehicleRegNo[0] || "";
  }
}
  